import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
// import { RootState, Dispatch } from '../../store';
import { isMobile } from '../../utils/helpers';
import PCAboutUs from './PCAbout-us';

const Home = () => {
  return isMobile() ? <PCAboutUs /> : <PCAboutUs />;
};

export default Home;
